import React, { useState } from "react";
import { Redirect } from "react-router-dom";
import { useStore } from "effector-react";
import { AccountsBlock } from "../../accounts/organoids/AccountsBlock";
import { ChargesBlock } from "../../charges/organoids/ChargesBlock";
import { CountersBlock } from "../../counters/organoids/CountersBlock";
import { loggedIn } from "../../login/logics/reg";
import { pathLogin } from "../../../common/config/vars";
import { $accounts } from "../../../common/accounts2";

import "../styles/Main.css";
import { keyIntfCounters, keyIntfCharges } from "../../../common/disabledInterfaces";
import { AccessControl } from "../../../common/ui/AccessControl";
import { PaymentsBlock } from "../../payments/organoids/Payments";
import { $SiteColors } from "../../../common/config/company-atts";
interface IMain {
  searchParams: object
}

export const Main = ({searchParams}: IMain) => {
  const { accounts } = useStore($accounts);
  const [lookButtonIsClicked, setLookButtonIsClicked] = React.useState(false);
  const [loading, setLoading]=useState<boolean>(false)
  return !loggedIn() ? ( // тут был !loggedIn()
    <Redirect to={pathLogin} />
  ) : (
    <section className="page__content page__content_overflow">
      <h1 className="page__title" style={{color:$SiteColors.getState().titleColor}}>Главная</h1>
      <div className="page__data" style={{backgroundColor:$SiteColors.getState().cardBackgroundColor}}>
        <AccountsBlock searchParams={searchParams}  setLookButtonIsClicked={setLookButtonIsClicked} loading={loading} setLoading={setLoading}/>
        {accounts.length !== 0 && !loading && (
          <>
            <AccessControl intf={keyIntfCounters} ok={<CountersBlock />} />
            <AccessControl intf={keyIntfCharges} ok={<ChargesBlock lookButtonIsClicked={lookButtonIsClicked} setLookButtonIsClicked={setLookButtonIsClicked}/>} />
            <PaymentsBlock />
          </>
        )}
      </div>
    </section>
  );
};
